import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CAccordionHeader,
  CAccordionItem,
  CAccordionBody,
  CAccordion,
  CTooltip,
} from '@coreui/react-pro'
import { loadStripe } from '@stripe/stripe-js'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import moment from 'moment'
import { Link } from 'react-router-dom'
import PricingPlanForClub from './PricingPlanForClub'
import PricingPlanForLeagues from './PricingPlanForLeagues'
import PricingPlanForMatchContest from './PricingPlanForMatchContest'

const FeeTable = () => {
  const [activationInfo, setActivationInfo] = useState({})
  const [gamePricingPlanDetails, setGamePricingPlanDetails] = useState({})
  const [gameQuotePlanDetails, setGameQuotePlanDetails] = useState({})
  const [gameInfo, setGameInfo] = useState(99)
  const [invoiceLink, setInvoiceLink] = useState(true)
  useEffect(() => {
    CommonService.getGameActivateInfo()
      .then((res) => {
        if (res.status === 200) {
          setActivationInfo(res.getGameActivationInfo)
          setGamePricingPlanDetails(res.gamePricingPlanDetails)
          setGameQuotePlanDetails(res.gameQuotePlanDetails)
          setGameInfo(res.game_info)
          if (res.getGameActivationInfo) {
            // console.log('activationInfo', activationInfo)
            const invoiceURL = JSON.parse(res.getGameActivationInfo.transaction_information)
            setInvoiceLink(invoiceURL.receipt_url)
          }
        }
      })
      .catch((e) => {
        console.log('E=> ', e)
        // ToastComponent('Something went wrong. Please try again.', 'error')
      })
  }, [])
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)
  const [userPricingData, setUserPricingData] = useState([])
  const [teamCount, setTeamCount] = useState(0)
  useEffect(() => {
    CommonService.getGamePricingData()
      .then((res) => {
        if (res.status === 200) {
          setUserPricingData(res.data)
          setTeamCount(res.teamCount)
        }
      })
      .catch((e) => {
        console.log('E=> ', e.getMessage())
        // ToastComponent('Something went wrong. Please try again.', 'error')
      })
  }, [])
  const handlePayNow = async (amount, productName, planType, minTeams, maxTeams) => {
    const stripe = await stripePromise
    const data = {
      amount: amount,
      product_name: productName,
      plan_type: planType,
      minTeams: minTeams,
      maxTeams: maxTeams,
    }

    CommonService.createCheckoutSession(data)
      .then(async (res) => {
        if (res?.id) {
          const sessionId = res.id
          const result = await stripe.redirectToCheckout({ sessionId })

          if (result.error) {
            ToastComponent(result.error.message, 'error')
          }
        } else {
          ToastComponent('Unable to create Stripe session.', 'error')
        }
      })
      .catch((error) => {
        console.error('Stripe session error:', error)
        const errorMessage =
          error?.response?.data?.error || 'Something went wrong while creating payment session'
        ToastComponent(errorMessage, 'error')
      })
  }
  const paidPlans = userPricingData?.filter((plan) => plan.is_paid === 1) || []
  const totalPaidAmount = paidPlans.reduce((sum, plan) => sum + parseInt(plan.amount || 0), 0)
  const paidPlanTypes = paidPlans.map((plan) => plan.plan_type)
  useEffect(() => {
    // Ensure the Stripe script is loaded before using the Stripe pricing table
    const script = document.createElement('script')
    script.src = 'https://js.stripe.com/v3/pricing-table.js'
    script.async = true
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <>
      {gameInfo?.game_type === 1 && (
        <CAccordion alwaysOpen activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <CTooltip content="Pricing Plan - Season Game (For Clubs)" placement="top">
                <strong>Pricing Plan - Season Game (For Clubs)</strong>
              </CTooltip>
            </CAccordionHeader>
            <CAccordionBody>
              {/* For Club */}

              <PricingPlanForClub
                teamCount={teamCount}
                activationInfo={activationInfo}
                gameInfo={gameInfo}
                paidPlanTypes={paidPlanTypes}
                totalPaidAmount={totalPaidAmount}
                handlePayNow={handlePayNow}
                invoiceLink={invoiceLink}
                gamePricingPlanDetails={gamePricingPlanDetails}
                gameQuotePlanDetails={gameQuotePlanDetails}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      )}
      {/* Pricing plan for leagues */}
      {(gameInfo?.game_type === 2 || gameInfo?.game_type === 3) && (
        <PricingPlanForLeagues
          teamCount={teamCount}
          activationInfo={activationInfo}
          gameInfo={gameInfo}
          paidPlanTypes={paidPlanTypes}
          totalPaidAmount={totalPaidAmount}
          handlePayNow={handlePayNow}
          invoiceLink={invoiceLink}
        />
      )}
      {/* Match Contest */}
      {!activationInfo && gameInfo?.game_type === 4 && (
        <stripe-pricing-table
          pricing-table-id="prctbl_1Qk2wAItsmZf8AkXjYi6mFME"
          publishable-key="pk_live_I2ZzJhqZwGTxEprRPJwLt4TE"
        ></stripe-pricing-table>
      )}
      {/* Transactions Table */}
      {activationInfo && activationInfo.is_paid === 1 && (
        <CCard className="mt-4">
          <CCardHeader>
            <strong>Transactions</strong>
          </CCardHeader>
          <CCardBody>
            <CTable>
              <CTableHead>
                <CTableRow>
                  <CTableHeaderCell scope="col">SN</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Invoice</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Amount</CTableHeaderCell>
                  <CTableHeaderCell scope="col">Paid On</CTableHeaderCell>
                </CTableRow>
              </CTableHead>
              <CTableBody>
                <CTableRow>
                  <CTableHeaderCell scope="row">1</CTableHeaderCell>
                  <CTableDataCell>
                    <a href={invoiceLink} target="_blank" rel="noreferrer">
                      Invoice
                    </a>
                  </CTableDataCell>
                  <CTableDataCell>${activationInfo?.fee}</CTableDataCell>
                  <CTableDataCell>
                    {moment(activationInfo?.created_at).format('D.MM.YYYY h:mm A')}
                  </CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>
          </CCardBody>
        </CCard>
      )}
    </>
  )
}

export default FeeTable
